import React from 'react';

import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { CurrencyPropType } from '../../prop-types/currency';
import { PackagePropType } from '../../prop-types/package';
import { FormattedCurrency } from '../../components/formatted-currency';
import LabelWithValue from './label-with-value';
import messages from './messages';
import PackageDetails from './package-details';
import style from './style.module.less';

const CarrierDetails = ({ carrier }) => {
  const {
    carrierDetail: { carrierTitle },
    methods: [method],
    packages,
    pickupDetail: { pickupLocationDetails: { pickupId = '', pickupName = '' } = {} } = {},
  } = carrier;
  const {
    timeInTransitOptions: { dispatchDate, deliveryDate },
    advancedFees: { shippingPrice, handlingFee, totalCharges },
    methodDetails: { methodTitle },
  } = method;

  return (
    <>
      <div className={style['shipment-details-grid']}>
        <div className={style['header-label']}>
          <FormattedMessage {...messages.shipmentInfoHeaderLabel} />
        </div>
        <div className={style['header-label']}>
          <FormattedMessage {...messages.dateAndTimeHeaderLabel} />
        </div>
        <div className={style['header-label']}>
          <FormattedMessage {...messages.shippingFeesHeaderLabel} />
        </div>
        <LabelWithValue label={<FormattedMessage {...messages.carrierTitleLabel} />} value={carrierTitle} />
        <LabelWithValue label={<FormattedMessage {...messages.dispatchDateHeaderLabel} />} value={dispatchDate} />
        <LabelWithValue
          label={<FormattedMessage {...messages.shippingFeeHeaderLabel} />}
          value={<FormattedCurrency currencyCode={shippingPrice.code} value={shippingPrice.value} />}
        />
        <LabelWithValue label={<FormattedMessage {...messages.methodHeaderLabel} />} value={methodTitle} />
        <LabelWithValue label={<FormattedMessage {...messages.deliveryDateHeaderLabel} />} value={deliveryDate} />
        <LabelWithValue
          label={<FormattedMessage {...messages.handlingFeeHeaderLabel} />}
          value={<FormattedCurrency currencyCode={handlingFee.code} value={handlingFee.value} />}
        />
        {pickupId ? <LabelWithValue label={<FormattedMessage {...messages.pickupLocationIdHeaderLabel} />} value={pickupId} /> : <div />}
        <div />
        <LabelWithValue
          label={<FormattedMessage {...messages.totalChargesHeaderLabel} />}
          value={<FormattedCurrency currencyCode={totalCharges.code} value={totalCharges.value} />}
        />
        {pickupName && <LabelWithValue label={<FormattedMessage {...messages.pickupLocationHeaderLabel} />} value={pickupName} />}
      </div>
      {packages.map((pack, index) => (
        <PackageDetails key={index} pack={pack} />
      ))}
    </>
  );
};

CarrierDetails.propTypes = {
  carrier: PropTypes.shape({
    carrierDetail: PropTypes.shape({
      carrierTitle: PropTypes.string,
    }),
    methods: PropTypes.arrayOf(
      PropTypes.shape({
        timeInTransitOptions: PropTypes.shape({
          dispatchDate: PropTypes.string,
          deliveryDate: PropTypes.string,
        }),
        advancedFees: PropTypes.shape({
          shippingPrice: CurrencyPropType,
          handlingFee: CurrencyPropType,
          totalCharges: CurrencyPropType,
        }),
        methodDetails: PropTypes.shape({
          methodTitle: PropTypes.string,
        }),
      }),
    ),
    packages: PropTypes.arrayOf(PackagePropType),
    pickupDetail: PropTypes.shape({
      pickupLocationDetails: PropTypes.shape({
        pickupId: PropTypes.string,
        pickupName: PropTypes.string,
      }),
    }),
  }).isRequired,
};

export default CarrierDetails;
